import React from 'react';
import './Add_step_1.css';

class Add_step_1 extends React.Component {
    render () {
        if (this.props.currentStep !== 1) {
            return null;
        }
        
        return (
           <div>
                <h2 className='center'>Let's add a gift recipient!</h2>
                
                <form>
                    <p className='form_label'>What is the recipient's name? </p>
                    <p className='form_label tiny_text'>The recipient could be your child, a different beneficiary, or even yourself!</p>
                    <input 
                        type='text' 
                        id='account_name' 
                        onChange={this.props.handleChange}
                        name='account_name' 
                        onBlur={(event) => {this.props.checkUnique(event, 'account_name')}}
                        placeholder='Name' 
                        value={this.props.account_name}
                        autoFocus
                        maxLength='50'
                        autoComplete='off'
                        />


                    <p className='form_label'>Recipient's birthday:</p>
                
                    <input 
                        type='text' 
                        id='birthday' 
                        onChange={this.props.handleDateChange}
                        value={this.props.birthday}
                        name='birthday' 
                        maxLength='10'
                        minLength='10'
                        placeholder='MM / DD / YYYY'
                         />
                    <p className='form_label small_text'>(If the recipient is not born yet, please put in a placeholder name for the account, and the estimated future birth date. You can change these later!)</p>
                
                </form>

                
           </div>
        );
    }
}

export default Add_step_1;